// extracted by mini-css-extract-plugin
module.exports = {"component":"player_component__I6lyI","player__bar":"player_player__bar__rgT59"};